if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      // formData object created to check whether multiple items are being added to a cart, else use the standard single item request
      const formData = new FormData(this.querySelector('form'));
      console.log(formData.has("items[0][id]"));
      // if multiple
      if(formData.has("items[0][id]")) {
        this.multipleItemRequestHandler(formData);
      }
      //else single
      else{
        this.singleItemRequestHandler();
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    //handles mulptiple item requests
    multipleItemRequestHandler(formData) {
      
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;
      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const items = [];
      // console.log(formData.get("items[0][id]"));
      // for (const key of formData.keys()) {
      //   console.log(key);
      // }

      // Manually construct the items array from the form data
      let currentItem = {};
      for (const [name, value] of formData.entries()) {
        // console.log([name, value]);
        if (name.startsWith('items[')) {
          if (name.includes('[id]')) {
            currentItem.id = value;
          } else if (name.includes('[quantity]')) {
            currentItem.quantity = parseInt(value, 10);
          }

          if (currentItem.id && currentItem.quantity > 0) { // Only add if ID and valid quantity exist
            items.push(currentItem);
            currentItem = {}; // Reset for the next item
          }
        }
      }

      const sectionId = window.systemPackagesSectionId;
      // console.log('Section ID from global variable:', sectionId);
      // Use sectionId as needed
    

      //console.log(items);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({items: items, 
        'section-id': sectionId,
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      console.log(config.body);
      if (items.length > 0) {
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          console.log(response);
          this.cartNotification.renderMultiItemContents(response);
        })
        .catch((e) => {
          console.error(e);
          
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
      }
    }

    //handles single item requests
    singleItemRequestHandler() {
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;
      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }
        this.cartNotification.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      });
    }
  });
}
